/**
 * sophior-facet-single-select.js
 * Radio-gedrag voor facetgroepen die als categorie-pills zijn gestyled
 * (houtsoort op de snijplanken-collectie): binnen zo'n groep vervangt een
 * nieuwe keuze de vorige — walnoot > esdoorn schakelt om in plaats van bij
 * te tellen. Andere groepen (prijs, overige filters) blijven combineren.
 *
 * Werkt samen met Dawn's FacetFiltersForm: die leest de formulierstatus pas
 * na een debounce van 800 ms, dus de zusjes synchroon uitvinken is genoeg —
 * geen extra render of event nodig (programmatic .checked = false vuurt geen
 * input-event, dus ook geen dubbele AJAX-render). Document-delegation
 * overleeft de AJAX-re-renders van het filtergrid; selectie op naam dekt
 * zowel de desktop-pills als de mobiele filter-drawer.
 */
(function () {
  if (window.__sophiorFacetSingleSelectInit) return;
  window.__sophiorFacetSingleSelectInit = true;

  // Houtsoort (bestaand), en sinds B3 (golf 2, D03 §3.2, 09 §4 RB-12) ook
  // Constructie (custom.zaagmethode) en Formaat (custom.size_label) zodra JP
  // die filters in Search & Discovery aanzet: binnen elke groep schakelt een
  // nieuwe keuze om (Walnoot > Esdoorn, Kopshout > Langshout, 42×30 > Set).
  var SINGLE_SELECT_FILTERS = [
    'filter.p.m.custom.houtsoort',
    'filter.p.m.custom.zaagmethode',
    'filter.p.m.custom.size_label'
  ];

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'checkbox' || !input.checked) return;
    if (SINGLE_SELECT_FILTERS.indexOf(input.name) === -1) return;

    document
      .querySelectorAll('input[type="checkbox"][name="' + input.name + '"]')
      .forEach(function (other) {
        if (other !== input && other.checked) other.checked = false;
      });
  });
})();
